/**
 * Variadic class-name joiner. Accepts strings, plus the false/null/undefined
 * values produced by short-circuit conditionals (`condition && styles.x`).
 */
export const cx = (...classes) => classes.filter(Boolean).join(' ');
//# sourceMappingURL=cx.js.map